import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/partnerships/page.tsx");
